import React from 'react';
import '../css/Supply.css'; 

const Supply = () => {
  return (
    <div className="supply-row">
      <div className="supply-card">
        <strong>Max supply</strong>
        <span>500.000.000</span>
      </div>
      <div className="supply-card">
        <strong>Algorithm</strong>
        <span>KawPow</span>
      </div>
      <div className="supply-card">
        <strong>Mainnet launching</strong>
        <span>April 27, 2024</span>
      </div>
      <div className="supply-card">
        <strong>ASICS Resistant</strong>
        <span>Yes</span>
      </div>
    </div>
  );
}

export default Supply;
